<template>
  <v-content >

    <template>
          
     <v-parallax  height="300"
    src="/static/buildinglow.jpg"><h2 class="text-center display-1">GUIDELINES FOR INTERNATIONAL STUDENTS</h2></v-parallax>

    </template>

<v-container wrap>
  
        <v-expansion-panels tile flat>
    <v-expansion-panel class=" grey lighten-2"
    >
      <v-expansion-panel-header><h2 class=" display-1 pa-3 pink--text text--darken-3">
         EXPLORE
        </h2></v-expansion-panel-header>
      <v-expansion-panel-content>
       
             <section row wrap mb-4 class="grey lighten-2 ma-1">
        
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout row wrap align-baseline>
               <v-flex class="  xs12 md6" 
            v-for="item in explore"
            :key="item.title"
            router
            :href="item.link">
                <v-sheet
          class="transparent pink--text text--darken-4"
          
          outlined
          tile
        >
          
         <h4> {{item.title}}</h4>

          <v-list
          class="transparent">
        <v-list-item
          v-for="items in item.subs"
            :key="items.title"
            router
            :href="items.link"
          link
        >

          <v-list-item-content>
            <v-list-item-title> <v-icon>mdi-arrow-right-bold</v-icon>
              {{ items.subtitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

        </v-sheet>
              </v-flex>     

            </v-layout>
          </v-container>
        </v-flex>
      </section>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    </v-container>
    
      <v-container >
      <v-flex>

        <v-flex xs10 offset-xs1 pt-5 px-5>
        <h3 class="text-center display-1">Transportation</h3>
      </v-flex>
      <v-container  class="pb-5 body-2">
        <p>Arrangements for pick up and drop will be arranged from Jaipur airport based on request.</p>

      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Housing and Accommodation</H3>
      </v-flex>
      <v-container  class="pb-5 body-2">
        <p>Hostel accommodation is available for all students. The hostel provides a cot, a mattress, 
            a study table, a chair and a cupboard for each student. Every hostel has uninterrupted electricity, 
            solar heated water facility, water cooler with aqua guard filters, common TV Room, 
            common reading room, etc. Some hostels have indoor games facilities and gymnasium. You will have to bring your own 
            soft furnishings and linen. All have attached bathrooms.</p>
        <p>No student should stay away from his/her room during the night except with prior written permission of the Warden. 
            Students are requested to avoid singing aloud, shouting or making all types of noises that is likely to distract the 
            attention of those who may be studying in their rooms or hostel libraries. Pets of all kinds are prohibited inside the hostel.
             Any damage caused to hostel property will be charged to the occupants of the room/block with a fine. Cooking in hostel rooms is 
             not permitted.</p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Security on Campus</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Manipal is a secured campus. Complete safety and security is ensured by the Block Supervisors, 
            Warden and Chief Warden (inside the Hostels) and by the Security Staff and Chief Security Officer (in and on the Campus). 
            At Manipal University Jaipur, all students are expected to abide by the rules and regulations of the University 
            and the code of conduct as applicable to Indian Students doing the same course. Any act within the campus that may violate 
            or spoil the academic atmosphere in the University will not be appreciated and the student found guilty of such offence will 
            be dismissed and sent back to their country without any cost to the University.</p>
        <!-- <p>For complaints/suggestions pertaining to security, please contact - <br/>
            Dr Prabhudev Mane<br/>
            Chief Operating Officer - Campus Safety<br/>
            Office: Room no. 107, I floor, University building<br/>
            Manipal<br/>
            Ph: 0820 2922848</p> -->
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Student Affairs</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>The Department of Student Affairs looks after the welfare of the students. With about 18,000 students studying in the university,
             it is imperative to have such a support group to look after their interests outside the classroom and provide special services. 
             The department's activities cover wide areas such as guidance, wellness, health and counselling and constantly evolves ways to
              support and foster students' interest in the university.</p>
        <p>General instructions for students on campus: <br/>
            <a href="https://manipal.edu/content/dam/manipal/mu/documents/OIAC/3b.%20Poster%20-%20Anti%20Ragging%20-%20Jul%202015.pdf">Anti Ragging - Jul 2015</a><br/>
            <a href="https://manipal.edu/content/dam/manipal/mu/documents/OIAC/3c.%20Poster%20-%20Health%20Instructions%20-%20Jul%202015.pdf">Health Instructions - Jul 2015</a><br/>
            <a href="https://manipal.edu/content/dam/manipal/mu/documents/OIAC/3d.%20Poster%20-%20Safety%20Instruction%20-%20Jul%202015.pdf">Safety Instruction - Jul 2015</a><br/>
            </p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Student Clinics</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Student Health Clinics are made available to students for Non-Accident and Non-Emergency cases. 
            With prior appointment students can avail medical aid at this clinic located at the 
             floor of New Out-Patient block, Kasturba Hospital. For details, <a href="https://manipal.edu/content/dam/manipal/mu/documents/OIAC/3a.%20poster%20-%20student%20health%20clinic_2014.pdf">click here.</a></p>
        <p>Contact information: <br/>
            Dr Suma Nair <br/>
            Director Student Affairs <br/>
            Office: Room no. 108, I floor, University building <br/>
            Manipal <br/>
            Phone: 91 820 2922035</p>
      </v-container>
      </v-flex>

        <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Library</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Manipal Academy of Higher Education has some of the best libraries in Asia. There are six major central libraries - 
            Health Sciences Library Manipal, Health Sciences Library Mangalore, MIT Library, MIC Library, WGSHA Library and MIM Library. 
            The University always strives to provide the latest and best collection of books, journals, online sources, dissertations, 
            etc to the students for course work and research.</p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Food</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>University Food Courts are located on campus with vide variety of food and beverages made available on campus. 
            Apart from these, students have plenty of options to taste different cuisines at the local hotels. <a href="https://manipal.edu/content/mu/campus-life/around-campus/campus-facilities/food-and-cuisine.html">click here</a></p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Internet</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Manipal Campus is equipped with excellent IT infrastructure. 
            The campus is completely wired through Optic Fibre Cable with Wi-Fi at most of the locations including hostels.</p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Local Phone Connection</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Need a local sim for conversing? Based on your requirement, 
            the service providers will be called at our office to offer you the best possible tariffs.</p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Sports Facilities</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>The campus has playground for cricket, hockey, football, tennis, basketball, badminton and volleyball with individual sports court. 
            Swimming pools, gymnasium, athletics track, walking track are made available at Manipal End Point to students and public in general. 
            All the sports activities at Manipal Academy of Higher Education are conducted under the supervision of the University Sports Council.
            MARENA, a six-storeyed indoor sports complex is a new attraction in Manipal. 
            The arena houses not just India’s largest gymnasium but also has a football pitch, badminton courts, basketball courts, 
            squash courts and a 200 meter synthetic jogging track. </p>

        <p> Want to become a member? <a href="http://manipal.edu/mu/manipal-life/campus-life/sports-overview/marena.html">click here</a></p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Identity Card</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Each student is issued an ID card/Combo card. This card will also function as Access Control card. Duplicate/replacement 
            ID card will be issued on payment on additional payment.</p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Dress Code</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>While we respect the dressing norms of different societies and culture, we also expect the students to adhere to 
            a befitting dress code while visiting the University office, attending the college for 
            lectures/practicals/library/labs/examinations and at the University’s formal functions. The dress code is applicable to 
            all students on campus, hence we seek your cooperation in abiding to these regulations.</p>

            <p>Recommended for Boys: <br/>
            <ul>
                <li>Formal/Semi formal wear</li>
                <li>Shoes/Formal footwear</li>
            </ul><br/>
            Recommended for Girls <br/>
            <ul>
                <li>Formal wear like salwar kameez, churidhar</li>
                <li>Any attire with sleeves on and trouser/skirt not above knee length</li>
                <li>Formal foot wears</li>
            </ul>
            </p>
      </v-container>
      </v-flex>

      <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">Visa Requirements</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>Foreign national has to have a valid Student Visa. Tourist visa is not acceptable. Student/s should -
            <ul>
                <li>mandatorily apply for ‘student’ visa OR</li>
                <li>‘X’ visa with special endorsement mentioning the purpose of visit</li>
            </ul>
        </p>
        <p>Students visiting on ‘tourist’ visa will not be entertained. 
            University has every right to withdraw the internship if the student comes on a tourist visa.
            <ul>
                <li>If the Student Visa expires during the course of their study, then such students have to apply 
                    for extension of visa at the Foreigners’ Regional Registration Office (FRRO) at Udupi or Mangalore at least 60 days prior to its expiry.</li>
                <li>Foreign nationals should also renew their RC and RP at the FRRO’s office at Udupi or Mangalore as and when 
                    it expires or if they come with a new student visa. They should also carry the document every time they travel to their 
                    country as this will have to be produced at the Immigration Counter in India before departure.</li>
            </ul>
            </p>
      </v-container>
      </v-flex>

      <!-- <v-flex>
      <v-flex xs10 offset-xs1 pt-5 px-5>
        <H3 class="text-center display-1">REGISTRATION AT FRRO</H3>
      </v-flex>
      <v-container class="pb-5 body-2">
        <p>All foreign students holding a Student Visa are required to register with the FRRO 
            (Superintendent of Police) within 14 days of their arrival in India.</p>
        <p>Students are required to register online 
            <a href="http://www.indianfrro.gov.in/frro/">(www.indianfrro.gov.in/frro)</a> 
            and then personally visit the FRRO to collect the documents based on the Unique ID number generated online. 
            The FRRO is located at the Office of Superintendent of Police at Udupi (5 kms from Manipal).</p>
        <p>Office of International Affairs & Collaborations will assist you through the online registration process and as well
             facilitate your visit to the FRO. Our office will guide you through the FRRO formalities. Please bring along your original 
             passport and 4 passport size photographs on your way into the office.</p>
      </v-container>
      </v-flex> -->

      </v-container>

  </v-content>
</template>

<script>
  export default {
    name: 'guidelines',
    data () {
      return {
        tab: null,
        text: '',

        tabs: 5,
      explore : [
      {title:'MUJ CENTER FOR INTERNATIONAL PROGRAMS', link:'',
      subs:[{subtitle:'About', link:'/about'},
              {subtitle:'Our Team', link:'/team'},
              /* {subtitle:'Contact', link:''} */
      ]},
      {title:'INTERNATIONAL ACADEMIC PROGRAMS', link:'',
      subs:[{subtitle:'Undergraduate Studies', link:'/undergraduate_studies'},
              {subtitle:'Postgraduate Studies', link:'/postgraduate_studies'},
              {subtitle:'PhD', link:'/phd'},
      ]},
      {title:'INTERNATIONAL ADMISSIONS', link:'',
      subs:[{subtitle:'How to Apply', link:'/apply'},
              {subtitle:'Register Online', link:'/application'},
              {subtitle:'Fee (Foreign/NRI)', link:'https://jaipur.manipal.edu/muj/admission/international-students/fees.html'},
              {subtitle:'Eligibility', link:'https://jaipur.manipal.edu/muj/admission/indian-students/who-can-apply.html'},
              {subtitle:'Course fee refund rules', link:'https://jaipur.manipal.edu/muj/admission/international-students/fees-refund.html'},
      ]},
      {title:'STUDY @ MUJ', link:'',
      subs:[{subtitle:'Academics', link:'https://jaipur.manipal.edu/muj/academics.html'},
              {subtitle:'Life @ MUJ', link:'/life_at_muj'},
              {subtitle:'Explore Rajasthan', link:'/rajasthan'}
      ]},
    ],
      }
    },
  }
</script>
